import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from "@material-ui/core";
import styled from "styled-components/macro";

export const StyledTable = styled(Table)`&& {
  border: 1px solid #DADCE0;
  font-family: Work Sans;
  font-weight: 300;
  width: 100vw;
}`;

export const StyledTableHead = styled(TableHead)`&& {
  background-color: #FAFAFA;
  color: #5F6368;
  font-size: 16px;
  font-family: Work Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
}`;

export const StyledTableHeadCell = styled(TableCell)`&& {
  font-family: Work Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  width: 18vw;
  padding: 0 1em 0 0;
}`;

export const StyledTableBody = styled(TableBody)`&& {
  font-size: 14px;
  font-weight: 300;
}`;

export const StyledBodyTableRow = styled(TableRow)`&& {
  background-color: #FFFFFF;
  height: 59px;
  && > td:nth-child(4)::first-letter {
    text-transform: lowercase;
  }
}`;

export const SpacerCell = styled(TableCell)`&& {
  width: 44px;
  padding: 0;
}`;

export const StyledBodyTableCell = styled(TableCell)`&& {
  font-size: 14px;
  font-family: Work Sans;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  width: 148px;
  padding: 0 1em 0 0;
  color: ${({ color }) => color ?? "#000000"};
  padding-left: ${({ center }) => center ? "1.5em" : "0"};
}`;
